import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { MerchantBasicDataReadonlyComponent } from '@merchant/components/merchant-basic-data-readonly/merchant-basic-data-readonly.component';
import { MerchantSitesComponent } from '@merchant/components/merchant-sites/merchant-sites.component';

import { ViewMerchantComponent } from '../easylot-admin-shared/components/view-merchant/view-merchant.component';
import { MerchantApprovalsComponent } from './components/merchant-approvals/merchant-approvals.component';

const routes: Routes = [
  {
    path: '',
    component: MerchantApprovalsComponent,
  },
  {
    path: 'view-merchant/:merchantId',
    component: ViewMerchantComponent,
    children: [
      {
        path: 'basic-data',
        component: MerchantBasicDataReadonlyComponent,
      },
      {
        path: 'sites',
        component: MerchantSitesComponent,
        data: {
          readOnly: true,
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MerchantApprovalsRoutingModule {}
